<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div class="container customplaceholder">
    <ul id="shipmentType" class="d-flex mb-5">
      <li
        v-for="item in listAir"
        :key="item.id"
        class="buttonselected d-flex justify-content-center align-items-center"
        :class="form.selectedFilter === item.value ? 'text-white bg-blue' : ''"
        @click="filterSelect(item.value)"
      >
        {{ item.name }}
      </li>
    </ul>
    <div>
      <p class="pdetail__header mb-2">
        {{ getLabelName(form.selectedFilter) }}
      </p>
      <div
        class="row m-0 w-100 pdetail__border justify-content-start align-items-center custom-radio"
      >
        <div
          v-for="(data, i) in getOptionType(form.selectedFilter)"
          :key="i"
          class="px-2"
          :class="
            getOptionType(form.selectedFilter).length < 5
              ? getOptionType(form.selectedFilter).length === 1
                ? 'col-md-6'
                : 'col-md'
              : 'col-md-3 mb-2'
          "
        >
          <div
            class="d-flex p-2"
            @click="option(data, form.selectedFilter)"
            style="z-index: 10; border-radius: 4px;"
            :style="
              selectedOption === data.value || selectedOption === data.size
                ? 'border: 1px solid #1D3354;'
                : 'border: 1px solid #DADEE2;'
            "
          >
            <input
              type="radio"
              id="selected"
              v-model="selectedOption"
              :value="data.value || data.size"
              class="mr-2"
              v-validate="'required'"
              :name="getLabelName(form.selectedFilter)"
              style="margin-top: 3px;"
            />
            <label class="m-0">{{ data.text || data.size }}</label>
          </div>
        </div>
      </div>
      <p
        v-if="errors.has(getLabelName(form.selectedFilter))"
        class="fontstyle__errormsg"
      >
        {{ errors.first(getLabelName(form.selectedFilter)) }}
      </p>
    </div>

    <p class="pdetail__header mb-2 mt-5">Shipment Detail</p>
    <div class="pdetail__border p-4 mb-5">
      <div class="d-flex mb-2">
        <div class="col-6">
          <p class="fontstyle__default">Which Position Are You in This?</p>
          <div class="options__multipleselect">
            <multiselect
              name="position"
              :state="errors.first('position') && false"
              v-validate="'required'"
              v-model="form.customerPosition"
              :options="optPosition"
              label="text"
              placeholder="Select shipment position"
              :select-label="''"
              :deselect-label="''"
              :allow-empty="false"
            >
              <span slot="noResult">Oops! No elements found.</span>
            </multiselect>
            <img
              class="options__multipleselect--imgabsolute"
              src="@/assets/image/icon/arrow-down-full-blue.svg"
            />
          </div>
          <p v-if="errors.has('position')" class="fontstyle__errormsg">
            {{ errors.first('position') }}
          </p>
        </div>
      </div>
      <div class="d-flex mb-2">
        <div class="col-6">
          <p class="fontstyle__default">Route Type</p>
          <div class="options__multipleselect">
            <multiselect
              name="route type"
              :state="errors.first('route type') && false"
              v-validate="'required'"
              v-model="form.routeType"
              :options="
                form.customerPosition.value === 'consignee'
                  ? optRouteTypeImp
                  : form.customerPosition.value === 'shipper'
                  ? optRouteTypeExp
                  : []
              "
              label="text"
              placeholder="Select"
              :select-label="''"
              :deselect-label="''"
            >
              <span slot="noResult">Oops! No elements found.</span>
            </multiselect>
            <img
              class="options__multipleselect--imgabsolute"
              src="@/assets/image/icon/arrow-down-full-blue.svg"
            />
            <p v-if="errors.has('route type')" class="fontstyle__errormsg">
              {{ errors.first('route type') }}
            </p>
          </div>
        </div>
        <div class="col-6 mt-1">
          <p class="fontstyle__default">Shipment Date</p>
          <div class="input__model1group">
            <b-input-group>
              <b-form-input
                v-model="form.datePickup"
                type="date"
                name="date"
                :min="getDate(new Date())"
                :state="errors.first('date') && false"
                v-validate="'required'"
              />
            </b-input-group>
            <p v-if="errors.has('date')" class="fontstyle__errormsg">
              {{ errors.first('date') }}
            </p>
          </div>
        </div>
      </div>
      <p class="pdetail__subtitle ml-3 mb-2 mt-3">Origin</p>
      <div class="d-flex mb-2">
        <div class="col-6">
          <p class="fontstyle__default">Origin Country</p>
          <div class="options__multipleselect">
            <multiselect
              name="origin country"
              :state="errors.first('origin country') && false"
              v-validate="'required'"
              v-model="form.originCountryCode"
              :options="countryList || []"
              label="name"
              placeholder="Origin Country"
              :select-label="''"
              :deselect-label="''"
            >
              <span slot="noResult">Oops! No elements found.</span>
            </multiselect>
            <img
              class="options__multipleselect--imgabsolute"
              src="@/assets/image/icon/arrow-down-full-blue.svg"
            />
            <p v-if="errors.has('origin country')" class="fontstyle__errormsg">
              {{ errors.first('origin country') }}
            </p>
          </div>
        </div>
        <div class="col-6">
          <p class="fontstyle__default">Origin City</p>
          <div class="options__multipleselect">
            <multiselect
              name="origin city"
              :state="errors.first('origin city') && false"
              v-validate="'required'"
              v-model="form.originCityCode"
              :options="cityList || []"
              label="name"
              track-by="name"
              :placeholder="isCityLoading ? 'Loading cities...' : 'Origin City'"
              :select-label="''"
              :deselect-label="''"
            >
              <span slot="noResult">Oops! No elements found.</span>
            </multiselect>
            <img
              class="options__multipleselect--imgabsolute"
              src="@/assets/image/icon/arrow-down-full-blue.svg"
            />
            <p v-if="errors.has('origin city')" class="fontstyle__errormsg">
              {{ errors.first('origin city') }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="col-12 mb-2"
        v-if="
          form.selectedServiceType === 'dtd' ||
            form.selectedServiceType === 'dtp' ||
            form.selectedFilter === 'BARGE' ||
            form.selectedFilter === 'LCT'
        "
      >
        <p class="fontstyle__default">
          Origin Address
          <span
            v-if="
              form.selectedFilter === 'BARGE' || form.selectedFilter === 'LCT'
            "
          >
            or Jetty Coordinate Point
          </span>
        </p>
        <div class="input__textarea">
          <b-form-textarea
            id="textarea"
            name="pick up"
            :state="errors.first('pick up') && false"
            v-validate="'required'"
            placeholder="Type Your Pick Up Address"
            rows="3"
            max-rows="5"
            v-model="form.pickupAddress"
          />
          <p v-if="errors.has('pick up')" class="fontstyle__errormsg">
            {{ errors.first('pick up') }}
          </p>
        </div>
      </div>
      <p class="pdetail__subtitle ml-3 mb-2 mt-3">Destination</p>
      <div class="d-flex mb-2">
        <div class="col-6">
          <p class="fontstyle__default">Destination Country</p>
          <div class="options__multipleselect">
            <multiselect
              name="destination country"
              :state="errors.first('destination country') && false"
              v-validate="'required'"
              v-model="form.destinationCountryCode"
              :options="countryList || []"
              label="name"
              placeholder="Destination Country"
              :select-label="''"
              :deselect-label="''"
            >
              <span slot="noResult">Oops! No elements found.</span>
            </multiselect>
            <img
              class="options__multipleselect--imgabsolute"
              src="@/assets/image/icon/arrow-down-full-blue.svg"
            />
            <p
              v-if="errors.has('destination country')"
              class="fontstyle__errormsg"
            >
              {{ errors.first('destination country') }}
            </p>
          </div>
        </div>
        <div class="col-6">
          <p class="fontstyle__default">Destination City</p>
          <div class="options__multipleselect">
            <multiselect
              name="destination city"
              :state="errors.first('destination city') && false"
              v-validate="'required'"
              v-model="form.destinationCityCode"
              :options="destinationCityList || []"
              label="name"
              :placeholder="
                isCityLoading ? 'Loading cities...' : 'Destination City'
              "
              :select-label="''"
              :deselect-label="''"
            >
              <span slot="noResult">Oops! No elements found.</span>
            </multiselect>
            <img
              class="options__multipleselect--imgabsolute"
              src="@/assets/image/icon/arrow-down-full-blue.svg"
            />
            <p
              v-if="errors.has('destination city')"
              class="fontstyle__errormsg"
            >
              {{ errors.first('destination city') }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="col-12"
        v-if="
          form.selectedServiceType === 'dtd' ||
            form.selectedServiceType === 'ptd' ||
            form.selectedFilter === 'BARGE' ||
            form.selectedFilter === 'LCT'
        "
      >
        <p class="fontstyle__default">
          Destination Address
          <span
            v-if="
              form.selectedFilter === 'BARGE' || form.selectedFilter === 'LCT'
            "
          >
            or Jetty Coordinate Point
          </span>
        </p>
        <div class="input__textarea">
          <b-form-textarea
            id="textarea"
            name="destination address"
            :state="errors.first('destination address') && false"
            v-validate="'required'"
            placeholder="Type your destination address"
            rows="3"
            max-rows="5"
            v-model="form.deliveryAddress"
          />
          <p
            v-if="errors.has('destination address')"
            class="fontstyle__errormsg"
          >
            {{ errors.first('destination address') }}
          </p>
        </div>
      </div>
    </div>

    <p class="pdetail__header mb-2">Shipment Data</p>
    <div
      v-if="
        form.selectedFilter === 'SEALCL' ||
          form.selectedFilter === 'SEABREAKBULK'
      "
      class="pdetail__border p-4 mb-5"
    >
      <div
        v-for="(item, i) in form.selectedFilter === 'SEALCL'
          ? form.loadsLCL
          : form.selectedFilter === 'SEABREAKBULK'
          ? form.loadsSEABreakbulk
          : []"
        :key="i"
      >
        <p class="pdetail__header mb-2">Detailed Information {{ i + 1 }}</p>
        <div class="d-flex mb-2">
          <div class="input__model1group col-4">
            <p class="fontstyle__default mb-1">Packages Quantity</p>
            <b-input-group>
              <b-form-input
                v-model="item.qty"
                placeholder="qty"
                v-validate="'required'"
                @input="totalQty()"
                name="Quantity"
                type="number"
                min="0"
                :formatter="formatMaxLenght10"
              />
            </b-input-group>
            <p v-if="errors.has('Quantity')" class="fontstyle__errormsg">
              {{ errors.first('Quantity') }}
            </p>
          </div>
          <div class="col-4">
            <p class="fontstyle__default">
              {{
                form.selectedFilter === 'SEALCL'
                  ? 'Cargo Packaging Type'
                  : 'UOM'
              }}
            </p>
            <div
              v-if="form.selectedFilter === 'SEALCL'"
              class="options__multipleselect"
            >
              <multiselect
                name="Satuan"
                v-validate="'required'"
                v-model="item.satuan"
                :options="optionQtyUnit || []"
                placeholder="Select cargo packaging type"
                label="name"
                track-by="name"
                :select-label="''"
                :deselect-label="''"
                :allow-empty="false"
              >
                <span slot="noResult">Oops! No elements found.</span>
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/arrow-down-full-blue.svg"
              />
              <p v-if="errors.has('Satuan')" class="fontstyle__errormsg">
                {{ errors.first('Satuan') }}
              </p>
            </div>
            <div v-else class="options__multipleselect">
              <multiselect
                name="UOM"
                v-validate="'required'"
                v-model="item.uom"
                :options="optionUOM || []"
                placeholder="Select uom"
                label="name"
                :select-label="''"
                :deselect-label="''"
                :allow-empty="false"
              >
                <span slot="noResult">Oops! No elements found.</span>
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/arrow-down-full-blue.svg"
              />
              <p v-if="errors.has('UOM')" class="fontstyle__errormsg">
                {{ errors.first('UOM') }}
              </p>
            </div>
          </div>
          <div class="input__model1group col-4">
            <p
              v-if="form.selectedFilter === 'SEALCL'"
              class="fontstyle__default mb-1"
            >
              Weight <span>Per {{ modifyUnitText(item.satuan) }} (Kg)</span>
            </p>
            <p
              v-if="form.selectedFilter === 'SEABREAKBULK'"
              class="fontstyle__default mb-1"
            >
              Weight (Kg)
            </p>
            <b-input-group>
              <b-form-input
                type="number"
                v-validate="'required'"
                placeholder="E.g: 1-1000"
                :formatter="formatMaxLenght10"
                v-model="item.weight"
                name="Weight"
                @input="totalQty()"
                min="0"
                trim
              ></b-form-input>
            </b-input-group>
            <p v-if="errors.has('Weight')" class="fontstyle__errormsg">
              {{ errors.first('Weight') }}
            </p>
          </div>
        </div>
        <div class="d-flex mb-2">
          <div class="input__model1group col-4">
            <p
              v-if="form.selectedFilter === 'SEALCL'"
              class="fontstyle__default"
            >
              Size <span>Per {{ modifyUnitText(item.satuan) }} (Cm)</span>
            </p>
            <p
              v-if="form.selectedFilter === 'SEABREAKBULK'"
              class="fontstyle__default"
            >
              Dimension (Meters)
            </p>
            <b-input-group>
              <b-form-input
                v-model="item.length"
                placeholder="W"
                v-validate="'required'"
                @input="totalQty()"
                aria-label="Length"
                name="Length"
                type="number"
                min="0"
                :formatter="formatMaxLenght6"
              />
            </b-input-group>
            <p v-if="errors.has('Length')" class="fontstyle__errormsg">
              {{ errors.first('Length') }}
            </p>
          </div>
          <div class="input__model1group col-4">
            <p class="fontstyle__default" style="color: #fff !important;">
              dfds
            </p>
            <div class="d-none">
              <b-input-group>
                <b-form-input
                  v-model="item.length"
                  placeholder="W"
                  v-validate="'required'"
                  @input="totalQty()"
                  aria-label="Length"
                  name="Length"
                  type="number"
                  min="0"
                  :formatter="formatMaxLenght6"
                />
              </b-input-group>
              <p v-if="errors.has('Length')" class="fontstyle__errormsg">
                {{ errors.first('Length') }}
              </p>
            </div>
            <b-input-group>
              <b-form-input
                v-model="item.width"
                placeholder="W"
                v-validate="'required'"
                @input="totalQty()"
                aria-label="Width"
                name="Width"
                type="number"
                min="0"
                :formatter="formatMaxLenght6"
              />
            </b-input-group>
            <p v-if="errors.has('Width')" class="fontstyle__errormsg">
              {{ errors.first('Width') }}
            </p>
          </div>
          <div class="input__model1group col-4">
            <p class="fontstyle__default" style="color: #fff !important;">
              dfds
            </p>
            <b-input-group>
              <b-form-input
                v-model="item.height"
                placeholder="H"
                v-validate="'required'"
                @input="totalQty()"
                aria-label="Height"
                name="Height"
                type="number"
                min="0"
                :formatter="formatMaxLenght6"
              />
            </b-input-group>
            <p v-if="errors.has('Height')" class="fontstyle__errormsg">
              {{ errors.first('Height') }}
            </p>
          </div>
        </div>
        <div
          v-if="form.selectedFilter !== 'SEABREAKBULK'"
          class="d-flex justify-content-end mr-3 mt-4"
        >
          <button
            v-if="i == form.loadsLCL.length - 1"
            class="pdetail__buttonwhite d-flex justify-content-center align-items-center mr-2"
            @click="addContainer"
          >
            <img
              class="mr-2"
              src="@/assets/image/icon/add-button-blue.svg"
              alt=""
            />
            Add Shipment Data
          </button>
          <button
            v-if="i || !i == form.loadsLCL.length > 1"
            class="pdetail__buttonred d-flex justify-content-center align-items-center mr-2"
            @click="removeContainer(i)"
          >
            <img
              class="mr-2"
              src="@/assets/image/icon/icon-tresh-red.svg"
              alt=""
            />
            Delete
          </button>
        </div>
      </div>
      <p
        v-if="form.selectedFilter === 'SEABREAKBULK'"
        class="pdetail__subtitle ml-3 mb-2 mt-4"
      >
        Additional Information
      </p>
      <div v-if="form.selectedFilter === 'SEABREAKBULK'" class="d-flex">
        <div class="col-6">
          <p class="fontstyle__default">Cargo Packaging Type</p>
          <div class="options__multipleselect">
            <multiselect
              name="Packing type"
              v-model="form.satuan"
              v-validate="'required'"
              :options="optionQtyUnit"
              placeholder="Select cargo packaging type"
              label="name"
              :select-label="''"
              :deselect-label="''"
              :allow-empty="false"
            >
              <span slot="noResult">Oops! No elements found.</span>
            </multiselect>
            <img
              class="options__multipleselect--imgabsolute"
              src="@/assets/image/icon/arrow-down-full-blue.svg"
            />
            <p v-if="errors.has('Packing type')" class="fontstyle__errormsg">
              {{ errors.first('Packing type') }}
            </p>
          </div>
        </div>
        <!-- <div class="input__model1group col-4">
          <p class="fontstyle__default mb-1">Quantity</p>
          <b-input-group>
            <b-form-input
              type="number"
              placeholder="E.g: 1-1000"
              :formatter="formatMaxLenght10"
              v-model="form.qtyperPackage"
              name="Qty"
              min="0"
              trim
            ></b-form-input>
          </b-input-group>
        </div> -->
      </div>
    </div>
    <div
      v-else-if="form.selectedFilter === 'SEAFCL'"
      class="pdetail__border p-4 mb-5"
    >
      <div v-for="(item, i) in form.loadsSEAFCL" :key="i">
        <p class="pdetail__header mb-2">Detailed Information {{ i + 1 }}</p>
        <div class="d-flex mb-2">
          <div
            :class="
              item.containerType && item.containerType.value === 'Reefer'
                ? 'col-5'
                : 'col-6'
            "
          >
            <p class="fontstyle__default">FCL Type</p>
            <div class="options__multipleselect">
              <multiselect
                name="FCL Type"
                v-model="item.shipmentType"
                :options="fclTypeOptions"
                label="text"
                placeholder="Select"
                v-validate="'required'"
                :select-label="''"
                :deselect-label="''"
                :allow-empty="false"
              >
                <span slot="noResult">Oops! No elements found.</span>
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/arrow-down-full-blue.svg"
              />
              <p v-if="errors.has('FCL Type')" class="fontstyle__errormsg">
                {{ errors.first('FCL Type') }}
              </p>
            </div>
          </div>
          <div
            :class="
              item.containerType && item.containerType.value === 'Reefer'
                ? 'col-5'
                : 'col-6'
            "
          >
            <p class="fontstyle__default">Container Type</p>
            <div class="options__multipleselect">
              <multiselect
                name="Container Type"
                v-model="item.containerType"
                :options="containerTypeOptions"
                label="text"
                placeholder="Select"
                v-validate="'required'"
                :select-label="''"
                :deselect-label="''"
                :allow-empty="false"
              >
                <span slot="noResult">Oops! No elements found.</span>
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/arrow-down-full-blue.svg"
              />
              <p
                v-if="errors.has('Container Type')"
                class="fontstyle__errormsg"
              >
                {{ errors.first('Container Type') }}
              </p>
            </div>
          </div>
          <div
            class="input__model1group col-2"
            v-if="item.containerType && item.containerType.value === 'Reefer'"
          >
            <p class="fontstyle__default mb-1">Temprature (C)</p>
            <b-input-group>
              <b-form-input
                type="number"
                v-validate="'required'"
                placeholder="E.g: 1-1000"
                v-model="item.temperature"
                name="Temprature"
                min="0"
                trim
              ></b-form-input>
            </b-input-group>
            <p v-if="errors.has('Temprature')" class="fontstyle__errormsg">
              {{ errors.first('Temprature') }}
            </p>
          </div>
        </div>
        <div class="d-flex mb-2">
          <div class="input__model1group col-6">
            <p class="fontstyle__default mb-1">Container Quantity</p>
            <b-input-group>
              <b-form-input
                type="number"
                v-validate="'required'"
                placeholder="E.g: 1-1000"
                :formatter="formatMaxLenght10"
                v-model="item.qty"
                name="Qty"
                min="0"
                trim
              ></b-form-input>
            </b-input-group>
            <p v-if="errors.has('Qty')" class="fontstyle__errormsg">
              {{ errors.first('Qty') }}
            </p>
          </div>
          <div class="col-6">
            <p class="fontstyle__default">Container Option</p>
            <div class="options__multipleselect">
              <multiselect
                name="Container option"
                v-validate="'required'"
                v-model="item.containerOption"
                :options="containerOptions || []"
                placeholder="Select cargo packaging type"
                label="text"
                :select-label="''"
                :deselect-label="''"
                :allow-empty="false"
              >
                <span slot="noResult">Oops! No elements found.</span>
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/arrow-down-full-blue.svg"
              />
              <p
                v-if="errors.has('Container option')"
                class="fontstyle__errormsg"
              >
                {{ errors.first('Container option') }}
              </p>
            </div>
          </div>
        </div>
        <div class="d-flex mb-2">
          <div class="col-6">
            <p class="fontstyle__default">Cargo Packaging Type</p>
            <div class="options__multipleselect">
              <multiselect
                name="Satuan"
                v-validate="'required'"
                v-model="item.satuan"
                :options="optionQtyUnit || []"
                placeholder="Select cargo packaging type"
                label="name"
                :select-label="''"
                :deselect-label="''"
                :allow-empty="false"
              >
                <span slot="noResult">Oops! No elements found.</span>
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/arrow-down-full-blue.svg"
              />
              <p v-if="errors.has('Satuan')" class="fontstyle__errormsg">
                {{ errors.first('Satuan') }}
              </p>
            </div>
          </div>
          <div class="input__model1group col-6">
            <p class="fontstyle__default mb-1">
              Weight <span>Per {{ modifyUnitText(item.satuan) }} Kg</span>
            </p>
            <b-input-group>
              <b-form-input
                type="number"
                v-validate="'required'"
                placeholder="E.g: 1-1000"
                :formatter="formatMaxLenght10"
                v-model="item.weight"
                name="Weight"
                min="0"
                trim
              ></b-form-input>
            </b-input-group>
            <p v-if="errors.has('Weight')" class="fontstyle__errormsg">
              {{ errors.first('Weight') }}
            </p>
          </div>
        </div>
        <div class="d-flex justify-content-end mr-3 mt-4">
          <button
            v-if="i == form.loadsSEAFCL.length - 1"
            class="pdetail__buttonwhite d-flex justify-content-center align-items-center mr-2"
            @click="addContainer"
          >
            <img
              class="mr-2"
              src="@/assets/image/icon/add-button-blue.svg"
              alt=""
            />
            Add Shipment Data
          </button>
          <button
            v-if="i || !i == form.loadsSEAFCL.length > 1"
            class="pdetail__buttonred d-flex justify-content-center align-items-center mr-2"
            @click="removeContainer(i)"
          >
            <img
              class="mr-2"
              src="@/assets/image/icon/icon-tresh-red.svg"
              alt=""
            />
            Delete
          </button>
        </div>
      </div>
    </div>
    <div
      v-else-if="
        form.selectedFilter === 'BARGE' || form.selectedFilter === 'LCT'
      "
      class="pdetail__border p-4 mb-5"
    >
      <div
        v-for="(item, i) in form.selectedFilter === 'BARGE'
          ? form.loadsSEABarge
          : form.selectedFilter === 'LCT'
          ? form.loadsSEALCT
          : []"
        :key="i"
      >
        <p class="pdetail__header mb-2">Detailed Information {{ i + 1 }}</p>
        <div class="mb-4">
          <p class="pdetail__subtitle mb-1">Packaging Type</p>
          <div class="row m-0 mt-2">
            <div
              v-for="(pack, j) in vesselPackingType"
              :key="j"
              class="col-md pdetail__packing"
              :style="j < 7 ? 'margin-right: 18px' : ''"
              :class="
                pack.value === getLoadsVessel(form.selectedFilter, 'satuan', i)
                  ? 'bg-blue'
                  : ''
              "
              @click="selectedVeselPacking(form.selectedFilter, pack.value, i)"
            >
              <img
                :src="pack.icon"
                alt=""
                :style="
                  pack.value === 'Roll' ? 'transform: rotate(90deg);' : ''
                "
              />
              <p>{{ pack.text }}</p>
            </div>
          </div>
        </div>
        <p class="pdetail__subtitle mb-1">Dimension per Package</p>
        <div class="row m-0">
          <div class="input__model1group col-md p-0 pr-3">
            <p class="fontstyle__default mb-1">Product Name</p>
            <b-input-group>
              <b-form-input
                v-model="item.productName"
                placeholder="Type product name"
                v-validate="'required'"
                name="Product Name"
                type="text"
              />
            </b-input-group>
            <p v-if="errors.has('Product Name')" class="fontstyle__errormsg">
              {{ errors.first('Product Name') }}
            </p>
          </div>
          <div class="input__model1group col-md p-0 pr-3">
            <p class="fontstyle__default mb-1">Weight per Package (Kg)</p>
            <b-input-group>
              <b-form-input
                type="number"
                v-validate="'required'"
                placeholder="E.g: 1-1000"
                :formatter="formatMaxLenght10"
                v-model="item.weight"
                name="Weight"
                @input="totalQty()"
                min="0"
                trim
              ></b-form-input>
            </b-input-group>
            <p v-if="errors.has('Weight')" class="fontstyle__errormsg">
              {{ errors.first('Weight') }}
            </p>
          </div>
          <div class="input__model1group col-md p-0">
            <p class="fontstyle__default mb-1">Quantity</p>
            <b-input-group>
              <b-form-input
                v-model="item.qty"
                placeholder="e.g : 1-1000"
                v-validate="'required'"
                @input="totalQty()"
                name="Quantity"
                type="number"
                min="0"
                :formatter="formatMaxLenght10"
              />
            </b-input-group>
            <p v-if="errors.has('Quantity')" class="fontstyle__errormsg">
              {{ errors.first('Quantity') }}
            </p>
          </div>
        </div>

        <div class="row m-0 mb-4 mt-3">
          <div class="input__model1group col-md p-0 pr-3">
            <p class="fontstyle__default mb-1">Length (cm) (Optional)</p>
            <b-input-group>
              <b-form-input
                v-model="item.length"
                placeholder="e.g : 1-1000"
                @input="totalQty()"
                aria-label="Length"
                name="Length"
                type="number"
                min="0"
                :formatter="formatMaxLenght6"
              />
            </b-input-group>
          </div>
          <div class="input__model1group col-md p-0 pr-3">
            <p class="fontstyle__default mb-1">Width (cm) (Optional)</p>
            <b-input-group>
              <b-form-input
                v-model="item.width"
                placeholder="e.g : 1-1000"
                @input="totalQty()"
                aria-label="Width"
                name="Width"
                type="number"
                min="0"
                :formatter="formatMaxLenght6"
              />
            </b-input-group>
          </div>
          <div class="input__model1group col-md p-0">
            <p class="fontstyle__default mb-1">Height (cm) (Optional)</p>
            <b-input-group>
              <b-form-input
                v-model="item.height"
                placeholder="e.g : 1-1000"
                @input="totalQty()"
                aria-label="Height"
                name="Height"
                type="number"
                min="0"
                :formatter="formatMaxLenght6"
              />
            </b-input-group>
          </div>
        </div>

        <p class="pdetail__subtitle mb-1">Stuffing Setting</p>
        <div class="input__textarea">
          <p class="fontstyle__default mb-1">Stuffing Note (Optional)</p>
          <b-form-textarea
            id="textarea"
            name="Stuffing Note"
            placeholder="Type stuffing setting note"
            rows="3"
            max-rows="5"
            v-model="item.note"
          />
        </div>
        <div></div>

        <div class="d-flex justify-content-end mr-3 mt-4">
          <button
            v-if="
              form.selectedFilter === 'BARGE'
                ? i == form.loadsSEABarge.length - 1
                : i == form.loadsSEALCT.length - 1
            "
            class="pdetail__buttonwhite d-flex justify-content-center align-items-center mr-2"
            @click="addContainer"
          >
            <img
              class="mr-2"
              src="@/assets/image/icon/add-button-blue.svg"
              alt=""
            />
            Add Product Details
          </button>
          <button
            v-if="
              form.selectedFilter === 'BARGE'
                ? i || !i == form.loadsSEABarge.length > 1
                : i || !i == form.loadsSEALCT.length > 1
            "
            class="pdetail__buttonred d-flex justify-content-center align-items-center mr-2"
            @click="removeContainer(i)"
          >
            <img
              class="mr-2"
              src="@/assets/image/icon/icon-tresh-red.svg"
              alt=""
            />
            Delete
          </button>
        </div>
      </div>
    </div>

    <p class="pdetail__header mb-2">Product Detail</p>
    <div class="pdetail__border p-4 mb-5">
      <ul
        v-if="form.selectedFilter !== 'BARGE' && form.selectedFilter !== 'LCT'"
        id="shipmentType"
        class="d-flex mb-5"
      >
        <li
          v-for="item in listProductDetail"
          :key="item.id"
          class="buttonselected d-flex justify-content-center align-items-center"
          :style="item.value !== 'DG' ? 'margin-right: 1rem' : ''"
          :class="
            form.selectedProduct === item.value ? 'text-white bg-blue' : ''
          "
          @click="filterSelectProduct(item.value)"
        >
          {{ item.name }}
        </li>
      </ul>
      <div v-else class="row m-0 mb-3">
        <div class="col-md">
          <p class="fontstyle__default">HS Code (Optional)</p>
          <div class="input__model1group">
            <b-input-group>
              <b-form-input
                v-model="form.hsCode"
                type="text"
                name="HS Code"
                placeholder="Type HS code"
              />
            </b-input-group>
          </div>
        </div>
        <div class="col-md">
          <p class="fontstyle__default">Ready to Load Date (Optional)</p>
          <div class="input__model1group">
            <b-input-group>
              <b-form-input
                v-model="form.loadDate"
                type="date"
                name="Load Date"
              />
            </b-input-group>
          </div>
        </div>
      </div>
      <div class="row m-0">
        <div class="col-md-6">
          <p class="fontstyle__default">PO Number (Optional)</p>
          <div class="input__model1group">
            <b-input-group>
              <b-form-input
                v-model="form.poNumber"
                type="text"
                name="PO Number"
                placeholder="Type PO number"
              />
            </b-input-group>
          </div>
        </div>
        <div v-if="form.selectedProduct === 'DG'" class="col-md-6 p-0 pr-3">
          <p class="fontstyle__default">UN Number</p>
          <div class="input__model1group">
            <b-input-group>
              <b-form-input
                v-model="form.unNumber"
                type="text"
                name="UN Number"
                placeholder="Type UN number"
                v-validate="'required'"
                :state="errors.first('UN Number') && false"
              />
            </b-input-group>
            <p v-if="errors.has('UN Number')" class="fontstyle__errormsg">
              {{ errors.first('UN Number') }}
            </p>
          </div>
        </div>
        <div
          class="col-md-6 pr-3 mb-3"
          v-if="
            form.selectedFilter === 'BARGE' || form.selectedFilter === 'LCT'
          "
        >
          <p class="fontstyle__default">Commodities</p>
          <div class="options__multipleselect">
            <multiselect
              name="commodities"
              :state="errors.first('commodities') && false"
              v-validate="'required'"
              v-model="form.productType"
              :options="commodities.data || []"
              :allow-empty="false"
              label="name"
              placeholder="Select commodity type or HS code"
              :select-label="''"
              :deselect-label="''"
            >
              <span slot="noResult">Oops! No elements found.</span>
            </multiselect>
            <img
              class="options__multipleselect--imgabsolute"
              src="@/assets/image/icon/arrow-down-full-blue.svg"
            />
          </div>
          <p v-if="errors.has('commodities')" class="fontstyle__errormsg">
            {{ errors.first('commodities') }}
          </p>
        </div>
        <div
          class="col-md-6"
          v-if="
            form.selectedFilter === 'BARGE' || form.selectedFilter === 'LCT'
          "
        >
          <div class="input__attachblue">
            <p class="fontstyle__default">
              Attach Packing List (Optional)
            </p>
            <b-form-file
              v-model="form.filePackingList"
              name="filePackingList"
              accept=".pdf, .xls, .doc, .docx, .xlsx"
              id="filePackingList"
              ref="filePackingList"
            />
            <p class="textdefault" style="font-size:10px">
              Allowed file type : doc, docx, xlsx, pdf (max. 5mb)
            </p>
            <div
              v-if="error.filePackingList"
              class="text-left input-group __input"
            >
              <small class="text-danger">{{ error.filePackingList }}</small>
            </div>
            <!-- <div v-if="error.fileType" class="text-left input-group __input">
              <small class="text-danger">File type is not supported</small>
            </div> -->
          </div>
        </div>
        <div class="col-md-6">
          <div class="input__attachblue">
            <p class="fontstyle__default">
              Attach MSDS
              <span v-if="form.selectedProduct !== 'DG'">(Optional)</span>
            </p>
            <b-form-file
              :required="form.selectedProduct === 'DG'"
              v-model="form.fileDocument"
              name="fileDocumentRfq"
              accept=".pdf, .xls, .doc, .docx, .xlsx"
              id="fileDocument"
              ref="fileDocument"
            />
            <p class="textdefault" style="font-size:10px">
              Allowed file type : doc, docx, xlsx, pdf (max. 5mb)
            </p>
            <div
              v-if="form.selectedProduct === 'DG' && !form.fileDocument"
              class="text-left input-group __input"
            >
              <small class="text-danger">Required File</small>
            </div>
            <div
              v-if="error.fileDocument"
              class="text-left input-group __input"
            >
              <small class="text-danger">{{ error.fileDocument }}</small>
            </div>
            <!-- <div v-if="error.fileType" class="text-left input-group __input">
              <small class="text-danger">File type is not supported</small>
            </div> -->
          </div>
        </div>
      </div>
      <div
        class="col-md-12"
        v-if="form.selectedFilter !== 'BARGE' && form.selectedFilter !== 'LCT'"
      >
        <p class="fontstyle__default">Commodities</p>
        <div class="input__textarea">
          <b-form-textarea
            id="textarea"
            name="Commodities"
            :state="errors.first('Commodities') && false"
            v-validate="'required'"
            placeholder="Type Commodities"
            rows="3"
            max-rows="5"
            v-model="form.commodities"
          />
          <p v-if="errors.has('Commodities')" class="fontstyle__errormsg">
            {{ errors.first('Commodities') }}
          </p>
        </div>
      </div>
    </div>

    <p class="pdetail__header mb-2">Additional</p>
    <div class="pdetail__border p-4 mb-5">
      <div class="d-flex mb-2">
        <div class="col-6">
          <p class="fontstyle__default">Insurance</p>
          <div class="options__multipleselect">
            <multiselect
              name="insurance"
              :state="errors.first('insurance') && false"
              v-validate="'required'"
              v-model="form.selectedInsurance"
              :options="insuranceOption"
              :allow-empty="false"
              label="name"
              placeholder="Select your insurance"
              :select-label="''"
              :deselect-label="''"
            >
              <span slot="noResult">Oops! No elements found.</span>
            </multiselect>
            <img
              class="options__multipleselect--imgabsolute"
              src="@/assets/image/icon/arrow-down-full-blue.svg"
            />
          </div>
          <p v-if="errors.has('insurance')" class="fontstyle__errormsg">
            {{ errors.first('insurance') }}
          </p>
        </div>
      </div>
      <div class="col-12 mb-2">
        <p class="fontstyle__default">Remarks (Optional)</p>
        <div class="input__textarea">
          <b-form-textarea
            id="textarea"
            name="Remarks"
            placeholder="Type Remarks"
            rows="3"
            max-rows="5"
            v-model="form.remarks"
          />
        </div>
      </div>
      <div id="checkboxAir" class="col-5">
        <p class="fontstyle__default">Additional Service</p>
        <b-form-checkbox
          id="checkbox-1"
          v-model="form.consigneeUndername"
          name="checkbox-1"
          value="true"
          unchecked-value="false"
        >
          Consignee Undername
        </b-form-checkbox>
        <b-form-checkbox
          id="checkbox-2"
          v-model="form.shipperUndername"
          name="checkbox-2"
          value="true"
          unchecked-value="false"
        >
          Shipper Undername
        </b-form-checkbox>
        <b-form-checkbox
          id="checkbox-3"
          v-model="form.warehouse"
          name="checkbox-3"
          value="true"
          unchecked-value="false"
        >
          Warehouse
        </b-form-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import {
  UNIT_COMMODITY_QUANTITY,
  UNIT_COMMODITY_QUANTITY_OCEAN_BREAKBULK,
  OPTIONS_UOM_BREAKBULK
} from '@/constant/options_list'
export default {
  name: 'formshipmentocean',
  props: {
    submitCheck: Boolean
  },
  data() {
    return {
      index: 1,
      isGeneral: true,
      isSpecial: false,
      isDangerous: false,
      selectedOption: '',
      form: {
        containerType: '', // untuk vessel
        productType: '', // untuk vessel
        loadDate: '', // untuk vessel
        hsCode: '', // untuk vessel
        selectedFilter: 'SEAFCL',
        selectedProduct: 'GENCO',
        selectedServiceType: '',
        customerPosition: '',
        routeType: '',
        datePickup: '',
        originCountryCode: '',
        originCityCode: '',
        pickupAddress: '',
        destinationCountryCode: '',
        destinationCityCode: '',
        deliveryAddress: '',
        poNumber: '',
        unNumber: '',
        fileDocument: null,
        filePackingList: null, // untuk vessel
        commodities: '',
        selectedInsurance: '',
        remarks: '',
        warehouse: false,
        shipperUndername: false,
        consigneeUndername: false,
        totalUnit: '',
        totalVolumetric: '',
        totalWeight: '',
        totalCBM: '',
        satuan: '',
        qtyperPackage: '',
        loadsLCL: [
          {
            qty: '',
            satuan: UNIT_COMMODITY_QUANTITY[5],
            weight: '',
            length: '',
            width: '',
            height: ''
          }
        ],
        loadsSEABreakbulk: [
          {
            qty: '',
            satuan: '',
            weight: '',
            width: '',
            length: '',
            height: '',
            qtyperPackage: '',
            uom: OPTIONS_UOM_BREAKBULK[0]
          }
        ],
        loadsSEAFCL: [
          {
            shipmentType: '',
            containerType: '',
            temperature: '',
            qty: '',
            containerOption: '',
            satuan: UNIT_COMMODITY_QUANTITY[5],
            weight: '',
            length: '',
            width: '',
            height: ''
          }
        ],
        loadsSEABarge: [
          {
            productName: '',
            qty: '',
            satuan: 'Box', // default
            weight: '',
            width: '',
            length: '',
            height: '',
            note: ''
          }
        ],
        loadsSEALCT: [
          {
            productName: '',
            qty: '',
            satuan: 'Box', // default
            weight: '',
            width: '',
            length: '',
            height: '',
            note: ''
          }
        ]
      },
      error: {
        fileDocument: '',
        filePackingList: ''
      },
      optionQtyUnit: UNIT_COMMODITY_QUANTITY,
      optionUOM: OPTIONS_UOM_BREAKBULK,
      optPosition: [
        { id: 1, text: 'Consignee', value: 'consignee' },
        { id: 2, text: 'Shipper', value: 'shipper' }
      ],
      optRouteTypeImp: [
        { id: 1, text: 'Import', value: 'import' },
        { id: 2, text: 'Domestic', value: 'domestic' }
      ],
      optRouteTypeExp: [
        { id: 1, text: 'Export', value: 'export' },
        { id: 2, text: 'Domestic', value: 'domestic' }
      ],
      listAir: [
        {
          id: 1,
          name: 'Full Container Load (FCL)',
          value: 'SEAFCL'
        },
        {
          id: 2,
          name: 'Less Container Load (LCL)',
          value: 'SEALCL'
        },
        {
          id: 3,
          name: 'Ocean Breakbulk',
          value: 'SEABREAKBULK'
        },
        {
          id: 4,
          name: 'Barge',
          value: 'BARGE'
        },
        {
          id: 5,
          name: 'LCT',
          value: 'LCT'
        }
      ],
      listProductDetail: [
        {
          id: 1,
          name: 'General Cargo',
          value: 'GENCO'
        },
        {
          id: 2,
          name: 'Special Cargo',
          value: 'SC'
        },
        {
          id: 3,
          name: 'Dangerous Goods',
          value: 'DG'
        }
      ],
      optionServiceType: [
        {
          id: 1,
          text: 'Door to Door',
          value: 'dtd'
        },
        {
          id: 2,
          text: 'Door to Port',
          value: 'dtp'
        },
        {
          id: 3,
          text: 'Port to Port',
          value: 'ptp'
        },
        {
          id: 3,
          text: 'Port to Door',
          value: 'ptd'
        }
      ],
      optionBargeType: [
        { id: 1, text: '250 Feet Jumbo', value: '250 Feet Jumbo' }
      ],
      optionLCTType: [
        {
          id: 1,
          text: 'LCT 1400 DWT (689 Ton)',
          value: 'LCT 1400 DWT (689 Ton)'
        }
      ],
      fclTypeOptions: [
        {
          id: 1,
          text: '20 FT Container',
          value: '20FT',
          shipmenttype: 'SEAFCL20FT'
        },
        {
          id: 2,
          text: '40 FT Container',
          value: '40FT',
          shipmenttype: 'SEAFCL40FT'
        },
        {
          id: 3,
          text: '45 FT Container',
          value: '45FT',
          shipmenttype: 'SEAFCL45FT'
        },
        {
          id: 4,
          text: '20 RF Container',
          value: '20RF',
          shipmenttype: 'SEAFCL20RF'
        },
        {
          id: 5,
          text: '40 HREF Container',
          value: '40HREF',
          shipmenttype: 'SEAFCL40HREF'
        },
        {
          id: 6,
          text: '40 FT High Cube',
          value: '40FT HC',
          shipmenttype: 'SEAFCL40FTHC'
        },
        {
          id: 7,
          text: '20 FR Container',
          value: '20FR',
          shipmenttype: 'SEAFCL20FR'
        },
        {
          id: 8,
          text: '40 FR Container',
          value: '40FR',
          shipmenttype: 'SEAFCL40FR'
        }
      ],
      containerTypeOptions: [
        { id: 1, text: 'Dry', value: 'Dry' },
        { id: 2, text: 'Ventilate', value: 'Ventilate' },
        { id: 3, text: 'Reefer', value: 'Reefer' },
        { id: 4, text: 'Open Top', value: 'Open Top' },
        { id: 5, text: 'ISO Tank', value: 'ISO Tank' },
        { id: 6, text: 'NOR', value: 'NOR' }
      ],
      containerOptions: [
        { id: 1, text: "Shipper's Own Container (SOC)", value: 'SOC' },
        { id: 2, text: "Carrier's Owned Container (COC)", value: 'COC' }
      ],
      vesselPackingType: [
        {
          id: 1,
          text: 'Box',
          value: 'Box',
          icon: require('@/assets/image/icon/pack-box.svg')
        },
        {
          id: 2,
          text: 'Big Bags',
          value: 'Big Bags',
          icon: require('@/assets/image/icon/pack-bag.svg')
        },
        {
          id: 3,
          text: 'Sacks',
          value: 'Sacks',
          icon: require('@/assets/image/icon/pack-sacks.svg')
        },
        {
          id: 4,
          text: 'Barrels',
          value: 'Barrels',
          icon: require('@/assets/image/icon/pack-barrels-roll.svg')
        },
        {
          id: 5,
          text: 'Roll',
          value: 'Roll',
          icon: require('@/assets/image/icon/pack-barrels-roll.svg')
        },
        {
          id: 6,
          text: 'Pipes',
          value: 'Pipes',
          icon: require('@/assets/image/icon/pack-pipes.svg')
        },
        {
          id: 7,
          text: 'Bulk',
          value: 'Bulk',
          icon: require('@/assets/image/icon/pack-bulk.svg')
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      cityList: 'city/city',
      countryList: 'city/country',
      isCityLoading: 'city/isLoading',
      isLoadingCountries: 'city/isLoadingCountries',
      //
      destinationCityList: 'city/destinationCities',
      isCityDestinationLoading: 'city/isLoadingDestination',

      insuranceOption: 'insurance/insuranceList',

      rfqData: 'rfq/item',
      isLoading: 'rfq/isLoading',
      isError: 'rfq/error',

      sizeBarge: 'vesselCharter/sizeBarge',
      errorSizeBarge: 'vesselCharter/errorSizeBarge',
      isLoadingSizeBarge: 'vesselCharter/isLoadingSizeBarge',

      sizeLCT: 'vesselCharter/sizeLCT',
      errorSizeLCT: 'vesselCharter/errorSizeLCT',
      isLoadingSizeLCT: 'vesselCharter/isLoadingSizeLCT',

      commodities: 'vesselCharter/commodities',
      errorDataCommodities: 'vesselCharter/errorDataCommodities',
      isLoadingDataCommodities: 'vesselCharter/isLoadingDataCommodities'
    }),
    pickupAddr() {
      return this.data.pickupAddress
    },
    deliveryAddr() {
      return this.data.deliveryAddress
    }
  },
  watch: {
    'form.customerPosition'(value) {
      if (value && !this.rfqData) {
        this.form.routeType = ''
      }
    },
    'form.routeType'(value) {
      if (value) return this.$emit('inputData', this.form)
    },
    'form.originCountryCode'(value) {
      if (value) {
        this.form.originCityCode = ''
        this.fetchCityOrigin(value.code)
      }
    },
    cityList(value) {
      if (this.rfqData) {
        this.form.originCityCode = value.filter(
          item => item.code === this.rfqData.city_from
        )[0]
      }
    },
    'form.originCityCode'(value) {
      if (value) return this.$emit('inputData', this.form)
    },
    'form.destinationCountryCode'(value) {
      if (value) {
        this.form.destinationCityCode = ''
        this.fetchCityDestination(value.code)
      }
    },
    destinationCityList(value) {
      if (this.rfqData) {
        this.form.destinationCityCode = value.filter(
          item => item.code === this.rfqData.city_to
        )[0]
      }
    },
    'form.destinationCityCode'(value) {
      if (value) return this.$emit('inputData', this.form)
    },
    'form.satuan'(value) {
      this.form.satuan = value
      this.form.loadsSEABreakbulk[0].satuan = value
    },
    submitCheck(value) {
      if (value) {
        this.checkSubmit()
      }
    },
    'form.fileDocument'(value) {
      if (value) {
        const convertToMb = value.size
        const maxSize = 5242880
        if (convertToMb > maxSize) {
          this.error.fileDocument =
            'Your file exceeded maximum requirement file'
        } else {
          this.error.fileDocument = ''
        }
      }
    },
    'form.filePackingList'(value) {
      if (value) {
        const convertToMb = value.size
        const maxSize = 5242880
        if (convertToMb > maxSize) {
          this.error.filePackingList =
            'Your file exceeded maximum requirement file'
        } else {
          this.error.filePackingList = ''
        }
      }
    },
    rfqData(data) {
      if (data.service_head === 'OCEAN') {
        this.form.selectedFilter =
          data.shipment_type === 'OCEANBREAKBULK'
            ? 'SEABREAKBULK'
            : data.shipment_type.includes('SEAFCL')
            ? 'SEAFCL'
            : data.shipment_type
        this.form.selectedProduct = data.product_class
        this.form.selectedServiceType = data.optiontp
        this.selectedOption = data.optiontp
        this.form.customerPosition = this.optPosition.filter(item =>
          data.customer_position.toLowerCase().includes(item.value)
        )[0]

        if (this.form.customerPosition.value === 'consignee') {
          this.form.routeType = this.optRouteTypeImp.filter(
            item => item.value === data.route_type.toLowerCase()
          )[0]
        } else {
          this.form.routeType = this.optRouteTypeExp.filter(
            item => item.value === data.route_type.toLowerCase()
          )[0]
        }

        this.form.originCountryCode = this.countryList.filter(
          item => item.code === data.country_from
        )[0]
        this.form.pickupAddress = data.pickup_address
        this.form.destinationCountryCode = this.countryList.filter(
          item => item.code === data.country_to
        )[0]
        this.form.deliveryAddress = data.delivery_address
        this.form.commodities = data.description
        this.form.selectedInsurance = data.m_insurance
        this.form.remarks = data.note_for_merchant
        this.form.warehouse = data.warehouse
        this.form.shipperUndername = data.shipper_undername
        this.form.consigneeUndername = data.consignee_undername

        if (this.form.selectedFilter.includes('SEAFCL')) {
          this.form.loadsSEAFCL = []
          JSON.parse(data.packing_list).forEach(shipment => {
            const tempFCL = {}
            const tempShipmentType = this.fclTypeOptions.filter(
              option => option.shipmenttype === shipment.shipmentType
            )
            if (tempShipmentType.length === 0) {
              tempFCL.shipmentType = this.fclTypeOptions.filter(
                option => option.value === shipment.shipmentType
              )[0]
            } else {
              tempFCL.shipmentType = tempShipmentType[0]
            }
            tempFCL.containerType = this.containerTypeOptions.filter(
              option => option.value === shipment.containerType
            )[0]
            tempFCL.temperature = shipment.temperature
            tempFCL.qty = shipment.qty
            tempFCL.containerOption = this.containerOptions.filter(
              option => option.value === shipment.containerOption
            )[0]
            tempFCL.satuan = UNIT_COMMODITY_QUANTITY.filter(
              option => option.value === shipment.satuan
            )[0]
            tempFCL.weight = shipment.weight
            tempFCL.length = shipment.length
            tempFCL.width = shipment.width
            tempFCL.height = shipment.height

            this.form.loadsSEAFCL.push(tempFCL)
          })
        } else if (this.form.selectedFilter === 'SEALCL') {
          this.form.loadsLCL = []
          JSON.parse(data.packing_list).forEach(shipment => {
            const tempLCL = {}
            tempLCL.qty = shipment.qty
            tempLCL.satuan = UNIT_COMMODITY_QUANTITY.filter(option =>
              option.value.includes(shipment.satuan)
            )[0]
            tempLCL.weight = shipment.weight
            tempLCL.length = shipment.length
            tempLCL.width = shipment.width
            tempLCL.height = shipment.height

            this.form.loadsLCL.push(tempLCL)
          })
        } else if (this.form.selectedFilter === 'SEABREAKBULK') {
          this.form.loadsSEABreakbulk = []
          JSON.parse(data.packing_list).forEach(shipment => {
            const tempSEABreakbulk = {}
            tempSEABreakbulk.qty = shipment.qty
            this.form.satuan = UNIT_COMMODITY_QUANTITY.filter(option =>
              option.value.includes(shipment.satuan)
            )[0]
            tempSEABreakbulk.satuan = UNIT_COMMODITY_QUANTITY.filter(option =>
              option.value.includes(shipment.satuan)
            )[0]
            tempSEABreakbulk.weight = shipment.weight
            tempSEABreakbulk.width = shipment.width
            tempSEABreakbulk.length = shipment.length
            tempSEABreakbulk.height = shipment.height
            tempSEABreakbulk.qtyperPackage = shipment.qtyperPackage
            tempSEABreakbulk.uom = OPTIONS_UOM_BREAKBULK.filter(
              option => option.value === shipment.uom
            )[0]

            this.form.loadsSEABreakbulk.push(tempSEABreakbulk)
          })
        } else if (this.form.selectedFilter === 'BARGE') {
          this.fetchVendorSizeBarge()
          this.fetchVesselCommodities()
          this.form.loadsSEABarge = []
          JSON.parse(data.packing_list).forEach((shipment, i) => {
            const tempBarge = {}
            tempBarge.qty = shipment.qty
            tempBarge.satuan = shipment.satuan
            tempBarge.weight = shipment.weight
            tempBarge.length = shipment.length
            tempBarge.width = shipment.width
            tempBarge.height = shipment.height
            tempBarge.productName = shipment.productName
            tempBarge.note = shipment.note
            this.form.loadsSEABarge.push(tempBarge)
          })
          this.form.hsCode = data.hs_code
          this.form.loadDate = data.load_date
          this.form.poNumber = data.po_number
          if (this.commodities && this.commodities.data) {
            const commoditiesOption = this.commodities.data
            const filterProductType = commoditiesOption.filter(
              item => item.name === data.product_type
            )[0]
            this.form.productType = filterProductType
          }
          this.selectedOption = data.service_sub_type
          this.form.containerType = data.service_sub_type
        } else if (this.form.selectedFilter === 'LCT') {
          this.fetchVendorSizeLCT()
          this.fetchVesselCommodities()
          this.form.loadsSEALCT = []
          JSON.parse(data.packing_list).forEach((shipment, i) => {
            const tempLCT = {}
            tempLCT.qty = shipment.qty
            tempLCT.satuan = shipment.satuan
            tempLCT.weight = shipment.weight
            tempLCT.length = shipment.length
            tempLCT.width = shipment.width
            tempLCT.height = shipment.height
            tempLCT.productName = shipment.productName
            tempLCT.note = shipment.note
            this.form.loadsSEALCT.push(tempLCT)
          })
          this.form.hsCode = data.hs_code
          this.form.loadDate = data.load_date
          this.form.poNumber = data.po_number
          if (this.commodities && this.commodities.data) {
            const commoditiesOption = this.commodities.data
            const filterProductType = commoditiesOption.filter(
              item => item.name === data.product_type
            )[0]
            this.form.productType = filterProductType
          }
          this.selectedOption = data.service_sub_type
          this.form.containerType = data.service_sub_type
        }
        this.totalQty()
      }
    }
  },
  created() {
    this.$eventHub.$on('duplicate-ocean', this.fetchRFQDetail)
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.$emit('inputData', this.form.selectedFilter)
      await this.$store.dispatch('city/FETCH_COUNTRIES')
      await this.$store.dispatch('insurance/INSURANCE_LIST')
      await this.fetchVesselCommodities()
    },

    fetchRFQDetail(id) {
      this.$store.dispatch('rfq/FETCH_RFQ_BY_ID', id)
    },

    fetchCityOrigin(value) {
      this.$store.dispatch('city/FETCH_CITIES', value)
    },
    fetchCityDestination(value) {
      this.$store.dispatch('city/FETCH_CITIES_DESTINATION', value)
    },

    fetchVendorSizeBarge() {
      this.$store.dispatch('vesselCharter/FETCH_SIZE_BARGE').then(() => {
        if (this.sizeBarge) {
          this.optionBargeType = this.sizeBarge.data
        }
      })
    },

    fetchVendorSizeLCT() {
      this.$store.dispatch('vesselCharter/FETCH_SIZE_LCT').then(() => {
        if (this.sizeLCT) {
          this.optionLCTType = this.sizeLCT.data
        }
      })
    },

    fetchVesselCommodities() {
      this.$store.dispatch('vesselCharter/FETCH_COMMODITIES')
    },

    modifyShipmentService(type) {
      this.form.data.optiontp = type
      if (type === 'ptp') {
        this.form.data.originArea = 'Port'
        this.form.data.destinationArea = 'Port'
        this.form.data.optiontp = 'ptp'
      } else if (type === 'dtp') {
        this.form.data.originArea = 'Door'
        this.form.data.destinationArea = 'Port'
        this.form.data.optiontp = 'dtp'
      } else if (type === 'ptd') {
        this.form.data.originArea = 'Port'
        this.form.data.destinationArea = 'Door'
        this.form.data.optiontp = 'ptd'
      } else if (type === 'dtd') {
        this.form.data.originArea = 'Door'
        this.form.data.destinationArea = 'Door'
        this.form.data.optiontp = 'dtd'
      }
    },
    modifyUnitText(unit) {
      let currentText = 'Quantity'
      switch (unit.value) {
        case 'Boxes':
          currentText = 'Box'
          break
        case 'Cartons':
          currentText = 'Carton'
          break
        case 'Cases':
          currentText = 'Case'
          break
        case 'Drums':
          currentText = 'Drum'
          break
        case 'Packages':
          currentText = 'Package'
          break
        case 'Palletes':
          currentText = 'Pallete'
          break
        case 'Charters':
          currentText = 'Charter'
          break
        case 'Units':
          currentText = 'Unit'
          break
        case 'CBM':
          currentText = 'CBM'
          break
        default:
          break
      }
      return currentText
    },
    totalQty() {
      if (this.form.selectedFilter === 'SEALCL') {
        let arr = this.form.loadsLCL
        this.form.totalUnit = arr.reduce(
          (total, obj) => parseInt(obj.qty ? obj.qty : 0) + parseInt(total),
          0
        )
        const currentTotalCBM = arr.reduce(
          (total, obj) =>
            parseFloat(this.calcVolume(obj || 0)) + parseFloat(total),
          0
        )
        this.form.totalCBM = !isNaN(currentTotalCBM)
          ? currentTotalCBM > 2.0
            ? currentTotalCBM.toFixed(3)
            : 2.0
          : 0
        this.form.totalWeight = arr.reduce(
          (total, obj) =>
            parseFloat(obj.weight ? obj.weight : 0) *
              parseInt(obj.qty ? obj.qty : 0) +
            parseFloat(total),
          0
        )
      } else if (this.form.selectedFilter === 'SEABREAKBULK') {
        this.form.totalUnit = this.form.loadsSEABreakbulk[0].qty
          ? this.form.loadsSEABreakbulk[0].qty
          : 0
        this.form.totalVolumetric =
          parseFloat(this.form.loadsSEABreakbulk[0].length) *
          parseFloat(this.form.loadsSEABreakbulk[0].width) *
          parseFloat(this.form.loadsSEABreakbulk[0].height) *
          parseFloat(this.form.loadsSEABreakbulk[0].qty)
        this.form.totalWeight = this.form.loadsSEABreakbulk[0].weight
          ? (parseFloat(this.form.loadsSEABreakbulk[0].weight) *
              parseFloat(this.form.totalUnit)) /
            1000
          : 0
      }
      this.$emit('inputData', this.form)
    },
    calcVolume(item) {
      const cbm = 1000000
      let vm = 0
      let volume = 0
      volume =
        parseFloat(item.length) *
        parseFloat(item.width) *
        parseFloat(item.height)
      vm = (parseFloat(volume / cbm) * item.qty).toFixed(3)
      return vm
      // return !isNaN(vm) ? vm > 2.000 ? vm : 2.000 : 0
    },
    checkSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (
            this.form.selectedProduct !== 'DG' ||
            this.form.selectedProduct === ''
          ) {
            return this.$emit('callBackSubmit', this.form)
          } else {
            if (!this.form.fileDocument)
              return this.$emit('callBackSubmit', false)
            return this.$emit('callBackSubmit', this.form)
          }
        } else {
          this.$emit('callBackSubmit', false)
        }
      })
    },
    chooseProductType(type) {
      this.isGeneral = type === 'General Cargo'
      this.isSpecial = type === 'Special Cargo'
      this.isDangerous = type === 'Dangerous Goods'
    },
    addContainer() {
      if (this.form.selectedFilter === 'SEAFCL') {
        this.form.loadsSEAFCL.push({
          shipmentType: '',
          containerType: '',
          temperature: '',
          qty: '',
          containerOption: '',
          satuan: UNIT_COMMODITY_QUANTITY[5],
          weight: '',
          length: '',
          width: '',
          height: ''
        })
      } else if (this.form.selectedFilter === 'SEALCL') {
        this.form.loadsLCL.push({
          qty: '',
          satuan: UNIT_COMMODITY_QUANTITY[5],
          weight: '',
          length: '',
          width: '',
          height: ''
        })
      } else if (this.form.selectedFilter === 'BARGE') {
        this.form.loadsSEABarge.push({
          qty: '',
          satuan: 'Box', // default
          weight: '',
          length: '',
          width: '',
          height: '',
          note: ''
        })
      } else if (this.form.selectedFilter === 'LCT') {
        this.form.loadsSEALCT.push({
          qty: '',
          satuan: 'Box', // default
          weight: '',
          length: '',
          width: '',
          height: '',
          note: ''
        })
      }
    },
    removeContainer(index) {
      if (this.form.selectedFilter === 'SEAFCL') {
        this.form.loadsSEAFCL.splice(index, 1)
      } else if (this.form.selectedFilter === 'SEALCL') {
        this.form.loadsLCL.splice(index, 1)
      } else if (this.form.selectedFilter === 'BARGE') {
        this.form.loadsSEABarge.splice(index, 1)
      } else if (this.form.selectedFilter === 'LCT') {
        this.form.loadsSEALCT.splice(index, 1)
      }
      this.totalQty()
    },
    filterSelect(value) {
      if (value === 'BARGE') {
        this.fetchVendorSizeBarge()
      } else if (value === 'LCT') {
        this.fetchVendorSizeLCT()
      }
      this.selectedOption = ''
      this.form.selectedFilter = value
      this.form.selectedServiceType = ''
      this.form.containerType = ''
      this.form.productType = ''
      this.form.loadDate = ''
      this.form.hsCode = ''
      this.form.customerPosition = ''
      this.form.routeType = ''
      this.form.datePickup = ''
      this.form.originCountryCode = ''
      this.form.originCityCode = ''
      this.form.pickupAddress = ''
      this.form.destinationCountryCode = ''
      this.form.destinationCityCode = ''
      this.form.deliveryAddress = ''
      this.form.totalWeight = ''
      this.form.totalUnit = ''
      this.form.totalVolumetric = ''
      this.form.selectedProduct = 'GENCO'
      this.form.unNumber = ''
      this.form.fileDocument = null
      this.form.filePackingList = null
      this.form.poNumber = ''
      this.form.loadsSEAFCL = [
        {
          shipmentType: '',
          containerType: '',
          temperature: '',
          qty: '',
          containerOption: '',
          satuan: UNIT_COMMODITY_QUANTITY[5],
          weight: '',
          length: '',
          width: '',
          height: ''
        }
      ]
      this.form.loadsLCL = [
        {
          qty: '',
          satuan: UNIT_COMMODITY_QUANTITY[5],
          weight: '',
          length: '',
          width: '',
          height: ''
        }
      ]
      this.form.loadsSEABreakbulk = [
        {
          qty: '',
          satuan: '',
          weight: '',
          width: '',
          length: '',
          height: '',
          qtyperPackage: '',
          uom: OPTIONS_UOM_BREAKBULK[0]
        }
      ]
      this.form.loadsSEABarge = [
        {
          productName: '',
          qty: '',
          satuan: 'Box', // default
          weight: '',
          width: '',
          length: '',
          height: '',
          note: ''
        }
      ]
      this.form.loadsSEALCT = [
        {
          productName: '',
          qty: '',
          satuan: 'Box', // default
          weight: '',
          width: '',
          length: '',
          height: '',
          note: ''
        }
      ]
      if (value === 'SEABREAKBULK') {
        this.optionQtyUnit = UNIT_COMMODITY_QUANTITY_OCEAN_BREAKBULK
      } else {
        this.optionQtyUnit = UNIT_COMMODITY_QUANTITY
      }
      this.$emit('inputData', this.form)
    },
    filterSelectProduct(value) {
      this.form.selectedProduct = value
      this.form.poNumber = ''
      this.form.unNumber = ''
      this.form.fileDocument = null
    },
    isDecimal(num) {
      if (num % 1 === 0) {
        return false
      }
      return true
    },
    formatMaxLenght10(e) {
      return String(e).substring(0, 10)
    },
    formatMaxLenght6(e) {
      return String(e).substring(0, 6)
    },
    getDate(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    option(data, type) {
      if (type === 'BARGE' || type === 'LCT') {
        this.form.containerType = data.size
        this.selectedOption = data.size
        this.$emit('inputData', this.form)
      } else {
        this.selectedOption = data.value
        this.form.selectedServiceType = data.value
      }
    },

    getOptionType(type) {
      let option = []
      if (type === 'SEAFCL' || type === 'SEALCL' || type === 'SEABREAKBULK') {
        option = this.optionServiceType
      } else if (type === 'BARGE') {
        option = this.optionBargeType
      } else if (type === 'LCT') {
        option = this.optionLCTType
      }
      return option
    },

    getLabelName(type) {
      let label = ''
      if (type === 'SEAFCL' || type === 'SEALCL' || type === 'SEABREAKBULK') {
        label = 'Shipment Service Type'
      } else if (type === 'BARGE') {
        label = 'Barge Type'
      } else if (type === 'LCT') {
        label = 'LCT Type'
      }
      return label
    },

    selectedVeselPacking(type, selectedValue, index) {
      if (type === 'BARGE') {
        this.form.loadsSEABarge[index].satuan = selectedValue
      } else if (type === 'LCT') {
        this.form.loadsSEALCT[index].satuan = selectedValue
      }
    },

    getLoadsVessel(type, typeItem, index) {
      let load = null
      if (type === 'BARGE') {
        if (typeItem === 'satuan') {
          load = this.form.loadsSEABarge[index].satuan
        }
      } else if (type === 'LCT') {
        if (typeItem === 'satuan') {
          load = this.form.loadsSEALCT[index].satuan
        }
      }
      return load
    }
  }
}
</script>

<style lang="scss" scoped>
#shipmentType {
  @media only screen and (min-width: 1536px) {
    margin: 0 0 2rem 0 !important;
  }
  display: flex;
  column-gap: 0.5rem;
  margin: 0 0 1rem 0 !important;
  padding: 0 !important;
}
.buttonselected {
  @media only screen and (min-width: 1536px) {
    height: 48px;
    font-size: 1em;
  }

  height: 36px;
  font-size: 0.9em;
  width: 520px;
  border-radius: 4px;
  border: 1px solid #dadee2;
  cursor: pointer;
}
.bg-blue {
  background-color: #1d3354 !important;
  color: #ffffff;
}
.bg-blue img {
  filter: brightness(0) invert(1);
}
.bg-blue p {
  color: #ffffff;
}
.custom-radio {
  width: 300px;
  border-radius: 4px;
  @media only screen and (min-width: 1536px) {
    padding: 1rem 1rem 1rem 3rem;
    font-size: 1em;
  }
  padding: 0.5rem 0.5rem 0.5rem 3rem;
  font-size: 0.8em;
  cursor: pointer;
}
input[type='radio']:after {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  top: -3px;
  left: -1px;
  position: relative;
  background-color: #d1d3d1;
  content: '';
  display: inline-block;
  visibility: visible;
  border: 2px solid white;
}
input[type='radio']:checked:after {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  top: -3px;
  left: -1px;
  position: relative;
  background-color: #1d3354 !important;
  content: '';
  display: inline-block;
  visibility: visible;
  border: 2px solid white;
}
.pdetail {
  &__header {
    font-size: 16px;
    font-weight: 700;
    color: #1d3354;
    @media only screen and (max-width: 1536px) {
      margin: 1.5rem 0rem 0.5rem 0rem !important;
    }
  }
  &__subtitle {
    font-size: 14px;
    font-weight: 700;
    color: #1d3354;
  }
  &__border {
    border: 1px solid #dadee2;
    border-radius: 8px;
    @media only screen and (min-width: 1536px) {
      padding: 1.5rem;
    }
    padding: 1rem;
    column-gap: 0;
  }
  &__buttonwhite {
    width: 185px;
    height: 36px;
    color: #1d3354;
    border: 1px solid #1d3354;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    background: #ffffff;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.011em;
  }
  &__buttonred {
    width: 100px;
    height: 36px;
    color: #c4232a;
    border: 1px solid #c4232a;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    background: #ffffff;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.011em;
  }
  &__packing {
    background-color: #ffffff;
    color: #1d3354;
    border-radius: 12px;
    box-shadow: -1px 0px 3px #ccc3c354;
    height: 120px;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    padding-top: 3%;
    &:hover {
      background-color: #1d3354;
      color: #ffffff !important;
      img {
        filter: brightness(0) invert(1);
      }
    }
  }
}
#checkboxAir {
  font-size: 14px !important;
  color: #686868 !important;
}

.customplaceholder {
  @media only screen and (min-width: 1536px) {
    width: 100%;
  }

  width: 73%;
}
</style>



// WEBPACK FOOTER //
// src/components/requestShipment/newRequestShipment/FormShipmentOcean.vue